import {moment} from 'external/moment'
import immutableUpdate from 'external/immutability-helper'
import { useContext, useMemo} from 'external/react'

import getName from 'utilities/enum'

import { cartService } from 'services/cart.service'
import Payment from 'context/payment-context'
import { isElective } from 'types/course'


export default function usePayment() {


	const {state, update} = useContext(Payment.Context)
    const {offersSummaryList: { initialized: initializedOffers, items: offers }, cart, props: {params}} = state
	const {properties: {offer: offerId, basic, elective, workbooks}} = cart

    const coursesInCart = useMemo(() => {
        const filterCart = (cart = []) =>  cart.map((id, cartIndex) => ({id, cartIndex})).filter(({id}) => id)
        return filterCart(basic).concat(filterCart(elective))
    }, [basic, elective])

	const basicCoursesInCart = useMemo(() => {
		const selectedCourses = (cart.properties.basic || []).filter(id => id)
		return selectedCourses
	}, [cart.properties])

    async function dettachCart() {
        localStorage.removeItem('cartId')
    }

    async function updateCart(type, index, id, action) {
        const value = action === 'delete' ? false : id
        const properties = type === 'basic' || type === 'elective'
            ? immutableUpdate(state.cart.properties, {
                offer: {$set: params.offerId},
                [type]: {[index]: {$set: value}},
                [`${type}Extra`]: {[index]: {$set: false}}
            })
            : immutableUpdate(state.cart.properties, {offer: {$set: params.offerId},[type]: {[index]: {$set: value}}})
        const updatedCart =  await cartService.saveCart({...state.cart, properties})
        update({cart: {properties: {$set: updatedCart.data.properties}}})
        return updatedCart
    }

    async function toggleWorkbook(id, value) {
        const properties = immutableUpdate(state.cart.properties, {workbooks: {[id]: {$set: value}}})
        update({cart: {properties: {$set: properties}}})
        return cartService.saveCart({...state.cart, properties})
    }

    async function emptyCart() {
        const defaultCart = length => Array(length).fill(false)
        const properties = immutableUpdate(state.cart.properties, {
            workbooks: {$set: {}},
            basic: {$set: defaultCart(5)},
            basicExtra: {$set: defaultCart(5)},
            elective: {$set: defaultCart(3)},
            electiveExtra: {$set: defaultCart(3)},
            offer: {$set: undefined}
        })
        update({cart: {properties: {$set: properties}}})
        return cartService.saveCart({...state.cart, properties})
    }
   
    const [selectedBasic, selectedElective] = useMemo(() => {
        const {basic, elective} = state.cart.properties
        return [basic || [], elective || []]
    }, [state.cart.properties])
    
    /*
    const offerCourses = useMemo(() => {
        if (!isUUID(params.offerId)) return []
        return state.offerCourses[params.offerId] || []
    }, [params.offerId, state.offerCourses])
    */
 
    const [packageItem, packageStatus] = useMemo(() => {
        if (initializedOffers) {
            const offer = offers.find(({id}) => id === offerId)
            if (!offer) return [undefined, {notFound: true, missingCourses: false, coursesCount: 0}]

            const findCourse = id => offer.courses.find(({course}) => id === course) || {}

            const courses = coursesInCart
                .map(({id, cartIndex}) => ({cartIndex, ...findCourse(id)}))
                .map(course => ({
                    cartIndex: course.cartIndex,
                    courseId: course.course,
                    courseName: course.name_course,
                    extraCourse: findCourse(course.id === 'C7' ? cart.properties.electiveExtra[course.cartIndex] : cart.properties.basicExtra[course.cartIndex]),
                    subjectName: course.name[course.language] || '',
                    subjectId: course.id,
                    offerId,
                    quantity: 1,
                    language: course.language,
                    workbookPrice: course.workbook_price,
                    workbook: course.workbook,
                    type: course.id === 'C7' ? 'elective' : course.licenseType,
                    cartIndex: course.cartIndex,
                    grade: course.grade,
                    gradeName: course.gradeName[course.language] || ''
                }))
            
            courses.sort((a, b) => a.courseId.localeCompare(b.courseId))

            const [workbooksCount, workbooksAmount] = courses.reduce((totals, {courseId, workbook, workbookPrice}) =>{
                if (workbook && workbooks[courseId]) {
                    totals[0] = totals[0] + 1
                    totals[1] = totals[1] + Number(workbookPrice)
                }
                return totals
            }, [0, 0])

            const price = Number(offer.price.slice(1))
            const subTotal = price + workbooksAmount

            
            const discounted = offer.discount && moment().isBetween(moment(offer.promotion.discount_start_date), moment(offer.promotion.discount_end_date)) 
            const discountAmountText = offer.promotion.discount_type === 'percent'
                ? `${offer.promotion.discount_amount}%`
                : `$ ${offer.promotion.discount_amount}`

            const paymentTotal = discounted
                ? (offer.promotion.discount_type === 'percent'
                    ? subTotal * (1 - parseFloat(offer.promotion.discount_amount) / 100)
                    : subTotal - Number(offer.promotion.discount_amount))
                : subTotal

            const packageItem = {
                offerId,
                offerName: offer.name,
                price,
                subTotal,
                courses,
                frequency: getName('frequency_unit', offer.frequency_unit),
                workbooksCount,
                workbooksAmount,
                discounted,
                discountAmountText,
                paymentTotal
            }

            const missingCoursesCount = courses.filter(({id, type}) => type === 'basic').length
            const missingCourses = missingCoursesCount < 5

            return [packageItem, {notFound: false, missingCourses, coursesCount: courses.length}]

        }
        return [undefined, {notFound: false, missingCourses: false, coursesCount: 0}]
    }, [initializedOffers, offerId, coursesInCart, offers, workbooks, cart.properties])


    const [packages, hasPackages] = useMemo(() => {
        const packages = (state.cart.properties.basic || []).concat(state.cart.properties.elective || []).filter(id => id)
        const hasPackages = packages.length > 0
        return [packages, hasPackages]
    }, [state.cart.properties])

  
    return {
        basic,
        elective,
        packageItem,
        packageStatus,
        packages, hasPackages,
        cart: state.cart,
        offers: state.offers,
        update, updateCart, emptyCart, toggleWorkbook, dettachCart,
        selectedBasic, selectedElective,
        offerCourses: [],
        courseInDetails: [],
        basicCoursesInCart
    }

}